module.exports = __webpack_public_path__ + "img/OpenFBA-Logo.f7164f7a.svg";